import React from "react";
import { toFixed } from "../CustomComponent";
import { blockStyle, cellMeta, MONTHLY_FORMS, toThaiYear } from "./constants";

const FORM_LABEL = {
  pgd1: "ภ.ง.ด.1",
  pgd3: "ภ.ง.ด.3",
  pgd53: "ภ.ง.ด.53",
  pp30: "ภ.พ.30",
  sso: "สปส.1-10",
};

// ปฏิทินภาษีรายเดือน: แถวคือเดือน คอลัมน์คือแบบภาษี กดที่ช่องเพื่อกรอกตัวเลขที่ยื่นจริง
export default function TaxCalendar({ summary, year, onOpenCell }) {
  const months = summary?.months || [];
  const totals = summary?.totals?.by_form || {};

  return (
    <div className="p-3 p-md-4" style={blockStyle}>
      <div className="d-flex justify-content-between align-items-center mb-3 gap-2 flex-wrap">
        <h6 className="fw-semibold mb-0">ปฏิทินภาษีรายเดือน ปี {toThaiYear(year)}</h6>
        <span className="small text-secondary">กดที่ตัวเลขเพื่อดูรายละเอียด/บันทึกยอดที่ยื่นจริง</span>
      </div>

      <div className="table-responsive">
        <table className="table table-hover align-middle mb-0">
          <thead className="table-light">
            <tr>
              <th className="text-secondary fw-medium">งวดเดือน</th>
              {MONTHLY_FORMS.map((form) => (
                <th key={form} className="text-secondary fw-medium text-end text-nowrap">{FORM_LABEL[form]}</th>
              ))}
              <th className="text-secondary fw-medium text-end text-nowrap">รวมทั้งเดือน</th>
            </tr>
          </thead>
          <tbody>
            {months.map((month) => (
              <tr key={month.period_month}>
                <td className="fw-semibold text-nowrap" style={{ color: "#12314d" }}>
                  {month.label}
                  {!month.has_data ? <div className="small text-secondary fw-normal">ยังไม่มีข้อมูล</div> : null}
                </td>

                {MONTHLY_FORMS.map((form) => {
                  const cell = month.forms[form];
                  const meta = cellMeta(cell);
                  const empty = !cell || (cell.total === 0 && cell.auto.tax === 0);

                  return (
                    <td key={form} className="text-end">
                      <button
                        type="button"
                        className="btn btn-link p-0 text-decoration-none"
                        style={{ color: empty ? "#9bb0a0" : meta.color, fontWeight: empty ? 400 : 600 }}
                        onClick={() => onOpenCell(cell)}
                      >
                        {empty ? "-" : toFixed(cell.total)}
                      </button>
                      {cell && !empty ? (
                        <div style={{ fontSize: "0.7rem", color: meta.color }}>
                          <i className="fa-solid fa-circle me-1" style={{ fontSize: "0.45rem" }} />
                          {meta.label}
                        </div>
                      ) : null}
                    </td>
                  );
                })}

                <td className="text-end fw-bold" style={{ color: "#12314d" }}>{month.total > 0 ? toFixed(month.total) : "-"}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr style={{ borderTop: "2px solid rgba(18, 125, 255, 0.2)" }}>
              <td className="fw-bold">รวมทั้งปี</td>
              {MONTHLY_FORMS.map((form) => (
                <td key={form} className="text-end fw-bold">{toFixed(totals[form]?.total)}</td>
              ))}
              <td className="text-end fw-bold" style={{ color: "#b63636" }}>{toFixed(summary?.totals?.tax_total)}</td>
            </tr>
            <tr>
              <td className="small text-secondary">ยื่น/จ่ายแล้ว</td>
              {MONTHLY_FORMS.map((form) => (
                <td key={form} className="text-end small" style={{ color: "#188251" }}>{toFixed(totals[form]?.paid)}</td>
              ))}
              <td className="text-end small fw-semibold" style={{ color: "#188251" }}>{toFixed(summary?.totals?.paid_total)}</td>
            </tr>
            <tr>
              <td className="small text-secondary">ค้างยื่น</td>
              {MONTHLY_FORMS.map((form) => (
                <td key={form} className="text-end small" style={{ color: "#b97007" }}>{toFixed(totals[form]?.pending)}</td>
              ))}
              <td className="text-end small fw-semibold" style={{ color: "#b97007" }}>{toFixed(summary?.totals?.pending_total)}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}
